import React from "react";
import ReactDOM from "react-dom";
// import "tachyons";
import "./index.css";
import "./assets/styles/index.scss";

import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
